module.exports = __webpack_public_path__ + "img/fullscreen-contract.b9abdfa6.png";